module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "prai-he"
  }, [_vm._v("Praise for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Get Stuff Done Without the Stress")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindent"
  }, [_vm._v("“Risa Williams not only knows how to get stuff done, she makes it seem easy, simple, and fun to do! Williams’s unique goal-mapping tools help us create what we want by being gentle and consistent with ourselves throughout the process and celebrating our accomplishments along the way. She encourages us to lean into a ‘self-kindness mindset’ vs. a ‘toxic productivity’ one, which is so important. Definitely a must-r"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ead")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("book!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindent0"
  }, [_vm._v("—Eden Byrne, psychotherapist and EMDR"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("pr"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("actitioner")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindent"
  }, [_vm._v("“This book is a must-read for anyone who struggles with burnout while working on goals. Risa Williams is an expert on a healthier and gentler approach to productivity, and "), _c('span', {
    staticClass: "Italic1"
  }, [_vm._v("Get Stuff Done Without the Stress")]), _vm._v(" has many practical tools and everyday mindset shifts for high achievers who also want to stay balanced across many areas of the"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ir")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("lives.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindentt"
  }, [_vm._v("—Sepideh Saremi, LCSW, founder of Run "), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Walk Talk®")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindent"
  }, [_vm._v("“This is a fantastic book that will teach you how to "), _c('span', {
    staticClass: "Italic1"
  }, [_vm._v("Get Stuff Done Without the Stress")]), _vm._v(". Often people create a false dichotomy between either being productive or de-stressing. Risa Williams expertly teaches you how to work smarter, not harder. If you are feeling overwhelmed by both needing to get things done and the stress of everything, this book is"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v(" for")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("you!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindentt"
  }, [_vm._v("—Scott Waltman, president elect of the Academy of Cognitive & Behavioral Therapies and author of "), _c('span', {
    staticClass: "Italic1"
  }, [_vm._v("The Stoicis")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic1"
  }, [_vm._v("m")])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic1"
  })]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic1"
  }, [_vm._v("Workbook")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindent"
  }, [_vm._v("“Powerful. Actionable. And entertaining! What more could you want from a book that helps you live your life purposes and reduce your stress? Highly"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("rec"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ommended!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindent"
  }, [_vm._v("—Eric Maisel, author of "), _c('span', {
    staticClass: "Italic1"
  }, [_vm._v("Choose Your Lif")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic1"
  }, [_vm._v("e")])]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic1"
  })]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic1"
  }, [_vm._v("Purposes")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-noindent"
  }, [_vm._v("“Risa Williams has done it again! Williams expertly breaks down the science of getting things done into bitesize chunks, making it incredibly easy to immediately make significant changes in your life. In the current ‘hustle climate,’ it is refreshing to read an easy-to-follow blueprint for healthy productivity. As a psychologist, this book will be a go-to resource that I can share with clients struggling with burnout, procrastination, and the mindset of toxic"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("prod"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("uctivity.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindentt"
  }, [_vm._v("—Tamara Soles, PhD, ps"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ychologist")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindent"
  }, [_vm._v("“Do you want to know a secret that will help you not only maximize your time but enjoy life more? Risa Williams shares "), _c('span', {
    staticClass: "Italic1"
  }, [_vm._v("five")]), _vm._v(" of them in her newest book, "), _c('span', {
    staticClass: "Italic1"
  }, [_vm._v("Get Stuff Done Without the Stress")]), _vm._v(". Yes, she’s done it again. This book is packed with tools, strategies, and insights on how to function well while getting things done effectively, providing a step-by-step pathway to freedom when you feel stuck, overwhelmed, or burnt out. There’s help on every page! Living calmly enables us to be more productive and do better work. When you encourage yourself and enjoy the process, you get more done and feel better for it! One key strategy is practicing the feelings you want to feel before you experience them. The practical, tried-and-tested tools in this book make that possible. Want Future You to feel better than you do now and boost your productivity? Keep Calm and Read t"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("his")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("Book!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindentt"
  }, [_vm._v("—Trevor Stockwell, author and leadership & personal develop"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ment")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("coach")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindent"
  }, [_vm._v("“Risa is a talented clinician that has the unique ability to create tangible tools to help people get past their stuck points. The tools contained in her book, "), _c('span', {
    staticClass: "Italic1"
  }, [_vm._v("Get Stuff Done Without the Stress")]), _vm._v(", are easily understandable and ready to be implemented. Risa makes the process of becoming a better version of yourself less"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("daunting.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindent"
  }, [_vm._v("—Stevon Lewis, author and"), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("therapist")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p-noindent"
  }, [_vm._v("“As a tech founder constantly juggling high stakes and intense demands, Risa Williams has been a transformative resource in my life. Her insights and practical tools have not only helped me manage anxiety but also equipped me to break free from the grip of toxic productivity and resist the relentless hustle culture. Through her approach to mindfulness, boundary setting, and emotional resilience, I’ve become a more grounded and focused founder, which has enhanced my ability to lead with clarity and compassion. I especially appreciate how Risa integrates traditional cognitive behavioral therapy with therapeutic practices, creating a holistic toolkit that has empowered me to thrive and show up as a bette"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("r")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("leader.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindentt"
  }, [_vm._v("—Ramona Ortega, Esq., CEO of WealthBuild.ai, leader of the THRIVE Campaign, public speaker, and fintech thou"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ght")]), _c('span', {
    staticClass: "noBreak"
  }), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("leader")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindent"
  }, [_vm._v("“"), _c('span', {
    staticClass: "Italic1"
  }, [_vm._v("Get Stuff Done Without the Stress")]), _vm._v(" is a refreshingly compassionate approach to productivity that transforms how we think about managing our time and achieving our goals. Rather than pushing readers toward burnout through toxic hustle culture, Risa Williams offers a revolutionary framework built on self-kindness, combining her expertise as a psychotherapist with practical tools that help readers maintain balance while making meaningful progress. Through evidence-based techniques like the Task Intensity Meter, Small Steps Journal, and Morning Reset, Williams teaches us how to break down overwhelming goals into manageable pieces while actively reducing stress and expanding our capacity for calm. Her engaging writing style and relatable examples make complex concepts accessible, while her emphasis on treating ourselves with the same compassion we show others provides a sustainable foundation for long-term success. This isn’t just another productivity book—it’s a gentle but powerful guide to getting things done while protecting our well-being and finding genuine joy in our"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("accompl"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ishments.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-noindent"
  }, [_vm._v("—Dr. Christopher Cortman, author and"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("ps"), _c('span', {
    staticClass: "noBreak"
  }, [_vm._v("ychologist")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d4cfe18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Front1.vue
// module id = 57
// module chunks = 0